<div class="md-form md-outline input-gplace">
  <input
    #inputGPlace
    mdbInput
    jhiMarkAsterisk
    jhiGooglePlaces
    type="text"
    class="form-control"
    [id]="id"
    [mdbValidate]="true"
    [validateSuccess]="false"
    [formControl]="control"
    [autocomplete]="'off'"
    [name]="id"
    [gplaceName]="id"
    (selectEvent)="setAddress($event)"
    [ngClass]="{ 'input-invalid-address': verify && !isAddressValid && (control.dirty || control.touched) }"
    [colorClass]="verify && !isAddressValid ? 'gplace-invalid-address' : 'gplace-valid-address'"
  />
  <label [for]="id" (click)="inputGPlace.focus()">{{ label }}</label>
  <mdb-error *ngIf="control && control.invalid && (control.dirty || control.touched) && verify">
    <span *ngIf="control.hasError('required')" jhiTranslate="ERROR.REQUIRED_FIELD"></span>
  </mdb-error>
  <!-- Gestion des erreurs de l'addressForm si et seulement si control est valid (pour éviter double message) -->
  <mdb-error id="addressFormSelect" *ngIf="verify && !isAddressValid && (control.dirty || control.touched)">
    <span jhiTranslate="components.gplace.incorrectAddress"></span>
  </mdb-error>
</div>
